import { render, staticRenderFns } from "./RecipientPanel.vue?vue&type=template&id=c4f4fe7a&scoped=true&"
import script from "./RecipientPanel.vue?vue&type=script&lang=ts&"
export * from "./RecipientPanel.vue?vue&type=script&lang=ts&"
import style0 from "./RecipientPanel.vue?vue&type=style&index=0&id=c4f4fe7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f4fe7a",
  null
  
)

export default component.exports